/** @param {string} letter */
export function normalizePersonalizationLetter(letter) {
  const c = String(letter || '')
    .trim()
    .toUpperCase()
    .replace(/[^A-Z]/g, '');
  return c.length === 1 ? c : '';
}

/** Default A–Z when admin leaves allowed letters empty. */
export const DEFAULT_CHAR_LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

/**
 * @param {import('./productPersonalization').ProductLike} product
 * @returns {string[]}
 */
export function allowedCharLettersForProduct(product) {
  const raw = String(product?.char_personalization_letters ?? '').trim();
  if (!raw) return [...DEFAULT_CHAR_LETTERS];
  const seen = new Set();
  const out = [];
  for (const part of raw.split(/[\s,;|]+/)) {
    const c = normalizePersonalizationLetter(part);
    if (c && !seen.has(c)) {
      seen.add(c);
      out.push(c);
    }
  }
  return out.length ? out : [...DEFAULT_CHAR_LETTERS];
}

/** Admin enabled single-letter picker for this product. */
export function productCharPersonalizationEnabled(product) {
  const v = product?.char_personalization;
  if (v === true || v === 1 || v === '1') return true;
  if (v === false || v === 0 || v === '0' || v == null || v === '') return false;
  return Boolean(v);
}

/** Free-text name/message at checkout (legacy personalized products). */
export function productTextPersonalizationAtCheckout(product) {
  if (productCharPersonalizationEnabled(product)) return false;
  const typ = String(product?.type || '').toLowerCase();
  const sub = String(product?.subcategory || '').toLowerCase();
  return typ === 'personalized' || sub.includes('personal');
}

/**
 * @param {string} letter
 * @param {import('./productPersonalization').ProductLike} product
 */
export function isAllowedCharLetter(letter, product) {
  const c = normalizePersonalizationLetter(letter);
  if (!c) return false;
  return allowedCharLettersForProduct(product).includes(c);
}

/** Label stored on orders / shown in cart — single letter for now. */
export function formatCharCustomizationLabel(letter) {
  const c = normalizePersonalizationLetter(letter);
  return c ? `Letter: ${c}` : '';
}
